import "./loading.scss";
import { Spin } from "antd";
const Loading = ({ isOpen, text = "" }) => {
  return (
    <>
      {isOpen && (
        <div className="loading-overlay ">
          <Spin spinning={true} size="large" tip={text}></Spin>
        </div>
      )}
    </>
  );
};

export default Loading;


